// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1Sq9B","noInteraction":"EventWrapper_noInteraction__1Nyx3"};